import stickerResource from "../resources/StickerResource";
import {BaseRepositoryBuilder} from "../../../../infrastructure/BaseRepositoryBuilder";
import {StickerItemRepository} from "../repositories/StickerItemRepository";
import {IStickerItem} from "../../store/entities/sticker-items/reducer";
import {ISticker} from "../../store/entities/stickers/reducer";

class StickerItemsRepositoryBuilder extends BaseRepositoryBuilder {
    constructor() {
        super(StickerItemRepository);
    }

    public buildWithSticker(sticker: ISticker): StickerItemRepository {
        return this.buildWithStickerId(sticker.id);
    }

    public buildWithStickerItem(stickerItem: IStickerItem): StickerItemRepository {
        return this.buildWithStickerId(stickerItem.sticker_id);
    }

    public buildWithStickerId(stickerId): StickerItemRepository {
        const resource = stickerResource.child(stickerId, 'items');
        return this.build(resource);
    }
}

const stickerItemsRepositoryBuilder: StickerItemsRepositoryBuilder = new StickerItemsRepositoryBuilder();
export default stickerItemsRepositoryBuilder;
